import { styled, SxProp, View } from 'dripsy';
import React, { useMemo } from 'react';
import { Image } from 'react-native';

export const HeaderBackgroundImageComponent: React.FC = () => {
  const ImageView = styled(Image)();
  const component = useMemo(() => {
    return (
      <View sx={sxStyles.backgroundHeader}>
        <ImageView sx={sxStyles.image} resizeMode="stretch" source={require('../../../../assets/images/ModalHeaderBG.jpg')} />
      </View>
    );
  }, []);

  return component;
};

const sxStyles: Record<string, SxProp> = {
  backgroundHeader: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  },
  image: {
    width: '100%',
    height: '100%'
  }
};
